export default __webpack_public_path__ + "static/media/office9small.c5b2ecdc.jpg";